import { useState, useLayoutEffect } from 'react'
import queryString from 'query-string'
import { useDispatch, useSelector } from 'react-redux'
import { setValue } from '@/store/slices/splitTest'
import { RootState } from '@/store/reducers'

declare const window: any

export function useSplitTest(varName: string) {
  const splitTest = useSelector((state: RootState) => state.splitTest)
  const dispatch = useDispatch()

  useLayoutEffect(() => {
    const query = queryString.parse(window.location.search)

    if (query[varName] !== undefined && query[varName] === 'true') {
      window[varName] = true
    } else if (query[varName] !== undefined && query[varName] === 'false') {
      window[varName] = false
    }

    if ( (window[varName] !== undefined && window[varName] === true)) {
      dispatch(setValue(true))
    } else if (window[varName] !== undefined && window[varName] === false) {
      dispatch(setValue(false))
    }

    Object.defineProperty(window, varName, {
      configurable: true,
      set(newValue) {
        if (newValue === true && query[varName] !== 'false') {
          dispatch(setValue(true))
        } else if (newValue === false && query[varName] !== 'true') {
          dispatch(setValue(false))
        }
      }
    })
  }, [])

  return splitTest.value
}
